import styled, { css } from 'styled-components';
import { CommonButtonInterface } from './Button';

export const Button = styled.button<CommonButtonInterface>`
  display: flex;

  ${(props) =>
    props.disabled &&
    css`
      background-color: #757575 !important;
    `}
  ${(props) => props.propCss}
`;

export const defaultButtonStyle = (options: any) => css`
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 64px;
  border-radius: 32px;
  padding: 0 40px;
  border: 1px solid #ffffff;
  background-color: ${(props) => props.theme.color.mainTheme};
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;

  ${options}

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    ${(props) => props.theme.mixin.convertMobileWidth('padding-left', 40)};
    ${(props) => props.theme.mixin.convertMobileWidth('padding-right', 40)};
    margin-right: 0;
    flex: 1;
  }
`;

export const defaultOutlineButtonStyle = css`
  background-color: transparent;
  color: ${(props) => props.theme.color.mainTheme};
  border-color: ${(props) => props.theme.color.mainTheme};
`;
